import { css } from '@linaria/core'
import { BUTTON_PADDINGS } from 'atoms/Button'
import {
  InputActionButtonIndentAdaptive,
  InputHeight,
  InputPaddingsAdaptive,
} from 'atoms/Input'
import { LABEL_PADDINGS } from 'atoms/Label'
import { EVENT_CARD_ASPECT_RATIO } from 'blocks/Cards'
import { CARDS_ASPECT_RATIO_VARS } from 'vars/cards-ascpect-ratio'
import {
  BANNER_ASPECT_RATIO,
  BANNER_BACK_BUTTON_INDENT,
  BANNER_DESCRIPTION_WIDTH,
  BANNER_HEIGHT,
  BANNER_PADDINGS,
  BANNER_WIDTH,
  BORDERS,
  BRAND_PADDINGS,
  CAROUSEL_PADDINGS,
  COLLECTION_GAPS,
  COLOR,
  CORNERS,
  DESCRIPTION_PADDINGS,
  EPG_SIDEBAR_SKELETON_SIZES,
  FIXED_INDENTS,
  FONT_FAMILY,
  FONTS,
  GRID,
  ICONS_SIZES,
  INDENTS,
  LABEL_INDENTS,
  LAYOUT,
  LAYOUT_BLOCK_PADDINGS,
  MC_PADDINGS,
  MEDIA,
  MULTI_COLUMN_GAP,
  NAVBAR_HEIGHT,
  NoContentIconSizes,
  PLAYER_BUTTON_SIZES,
  PLAYER_LAYOUT,
  PLAYER_PROGRESS,
  PopupLayout,
  PROGRESS_SIZES,
  ROW_CONTAINER_VERTICAL_GAPS,
  ROW_GAP,
  SHADOW,
  TEXT_SHADOW,
  TRANSITIONS,
} from 'vars/index'

export const variables = css`
  ${COLOR.TEXT_ICON_PRIMARY}: #f5f5f5;
  ${COLOR.TEXT_ICON_SECONDARY}: #b2b1b1;
  ${COLOR.TEXT_ICON_TERTIARY}: #4f4f4f;
  ${COLOR.TEXT_ICON_CONSTANT_LIGHT}: #ffffff;
  ${COLOR.TEXT_ICON_CONSTANT_DARK}: #1a1a1a;

  ${COLOR.ADDITIONAL_RED}: #ff5975;
  ${COLOR.ADDITIONAL_RED_2}: #d15066;
  ${COLOR.ADDITIONAL_RED_3}: #fe2121;
  ${COLOR.ADDITIONAL_ORANGE}: #ffbf59;
  ${COLOR.ADDITIONAL_ORANGE_2}: #ff7759;
  ${COLOR.ADDITIONAL_ORANGE_3}: #ff5959;
  ${COLOR.ADDITIONAL_GREEN}: #5cb15f;
  ${COLOR.ADDITIONAL_PURPLE}: #9f59ff;
  ${COLOR.ADDITIONAL_BLUE}: #59c8ff;
  ${COLOR.ADDITIONAL_BLUE_2}: #596eff;

  ${COLOR.SUBTITLE_WHITE}: #fbfbfb;
  ${COLOR.SUBTITLE_BLUE}: #0047ff;
  ${COLOR.SUBTITLE_GREEN}: #0fbf00;
  ${COLOR.SUBTITLE_MAGENTA}: #f64cfa;
  ${COLOR.SUBTITLE_YELLOW}: #ffdf35;
  ${COLOR.SUBTITLE_RED}: #f92121;
  ${COLOR.SUBTITLE_BLACK}: #151515;
  ${COLOR.SUBTITLE_CYAN}: #00ffff;

  ${COLOR.BASE_MAIN_DEFAULT}: #fff;
  ${COLOR.BASE_MAIN_PRESSED}: #b2b2b2;

  ${COLOR.MAIN_GRADIENT_0}: linear-gradient(
    0deg,
    #141515 0%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.MAIN_GRADIENT_90}: linear-gradient(
    90deg,
    #141515 0%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.MAIN_GRADIENT_180}: linear-gradient(
    180deg,
    #141515 0%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.MAIN_GRADIENT_270}: linear-gradient(
    270deg,
    #141515 0%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.BUNDLE_LAYOUT_OVERLAY}: linear-gradient(
    0deg,
    #141515 0%,
    rgba(20, 21, 21, 0.83) 85.82%,
    rgba(20, 21, 21, 0.5) 95.36%
  );
  ${COLOR.TOA_LAYOUT_OVERLAY}: linear-gradient(
    360deg,
    #141515 83%,
    rgba(20, 21, 21, 0) 115%
  );
  ${COLOR.ROW_MAIN_GRADIENT_0}: linear-gradient(
    0deg,
    rgba(20, 21, 21, 0) 65.55%,
    #141515 100%
  );
  ${COLOR.ROW_MAIN_GRADIENT_1}: linear-gradient(
    0deg,
    #141515 0.1%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.ROW_MAIN_GRADIENT_2}: linear-gradient(
    132.71deg,
    #bb86fc 3.91%,
    #331978 100%
  );

  ${COLOR.SURFACE_DARK}: #0d0d0d;
  ${COLOR.SURFACE_DARK_2}: #121212;
  ${COLOR.SURFACE_DARK_3}: #141515;
  ${COLOR.SURFACE_DARK_4}: #1a1a1a;
  ${COLOR.SURFACE_DARK_6}: #333333;
  ${COLOR.SURFACE_DARK_7}: #4c4c4c;
  ${COLOR.SURFACE_DARK_5}: #252525;
  ${COLOR.SURFACE_LIGHT_1}: #3b3b3b;
  ${COLOR.SURFACE_LIGHT_2}: #e6e6e6;
  ${COLOR.SURFACE_CONSTANT_LIGHT}: #f5f5f5;

  ${COLOR.BORDER_SECONDARY}: #808080;

  ${COLOR.ACCENT_WARNINGS_HOVERED}: #c33c53;
  ${COLOR.ACCENT_WARNINGS_PRESSED}: #b83148;

  ${COLOR.ACCENT_TERTIARY}: #bb86fc;
  ${COLOR.PROGRESS_BAR_ACCENT_SECONDARY}: #9161d8;
  ${COLOR.ACCENT_SECONDARY}: #9161d8;
  ${COLOR.ACCENT_PRIMARY_PRESSED}: #6c43b5;

  ${COLOR.ACCENT_PRIMARY_PRESSED_OVERLAY}: rgba(51, 51, 51, 0.5);
  ${COLOR.ACCENT_PRIMARY_HOVERED_OVERLAY}: rgba(255, 255, 255, 0.2);
  ${COLOR.ACCENT_PRIMARY_DISABLED_OVERLAY}: rgba(37, 37, 37, 1);

  ${COLOR.ACCENT_PRIMARY_GRADIENT}: linear-gradient(
    135deg,
    #bb86fc 0%,
    #331978 100%
  );
  ${COLOR.BUTTON_ACCENT_PRIMARY}: #7430ef;
  ${COLOR.BUTTON_ACCENT_PRIMARY_GRADIENT}: linear-gradient(
    135deg,
    #bb86fc 0%,
    #331978 100%
  );
  ${COLOR.CATEGORY_CARD_ACCENT_PRIMARY_GRADIENT}: linear-gradient(
    135deg,
    #bb86fc 0%,
    #331978 100%
  );

  ${COLOR.DISABLED}: #2c2c2c;

  ${COLOR.SURFACE_OPACITY_LIGHT_10}: rgba(255, 255, 255, 0.1);
  ${COLOR.SURFACE_OPACITY_LIGHT_15}: rgba(255, 255, 255, 0.15);
  ${COLOR.SURFACE_OPACITY_LIGHT_20}: rgba(255, 255, 255, 0.2);
  ${COLOR.TRANSPARENT}: transparent;

  ${COLOR.SURFACE_OPACITY_DARK_25}: rgba(0, 0, 0, 0.25);
  ${COLOR.SURFACE_OPACITY_DARK_40}: rgba(0, 0, 0, 0.4);
  ${COLOR.SURFACE_OPACITY_DARK_50}: rgba(0, 0, 0, 0.5);
  ${COLOR.SURFACE_OPACITY_DARK_60}: rgba(0, 0, 0, 0.6);
  ${COLOR.SURFACE_OPACITY_DARK_70}: rgba(0, 0, 0, 0.7);
  ${COLOR.SURFACE_OPACITY_DARK_80}: rgba(0, 0, 0, 0.8);

  ${COLOR.OVERLAY_DEFAULT}: rgba(0, 0, 0, 0.15);
  ${COLOR.OVERLAY_HOVERED}: rgba(0, 0, 0, 0.25);
  ${COLOR.OVERLAY_PRESSED}: rgba(0, 0, 0, 0.35);
  ${COLOR.OVERLAY_SHADOW}: rgba(0, 0, 0, 0.5);
  ${COLOR.CARD_VERTICAL_OVERLAY}: linear-gradient(
    0deg,
    #000000 0%,
    rgba(0, 0, 0, 0) 100%
  );
  ${COLOR.EPISODE_CARD_VERTICAL_OVERLAY}: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 50%
  );
  ${COLOR.EVENT_CARD_VERTICAL_OVERLAY}: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 70%,
    rgba(0, 0, 0, 0.9) 100%
  );
  ${COLOR.PROGRESS_LINE_OVERLAY}: linear-gradient(
    90deg,
    transparent 0%,
    rgba(228, 207, 254, 0.1) 100%
  );

  ${COLOR.BANNER_HORIZONTAL_OVERLAY}: linear-gradient(
    to right,
    #141515 0%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.BANNER_VERTICAL_OVERLAY}: linear-gradient(
    to top,
    #141515 0%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.BANNER_DETAILS_VERTICAL_OVERLAY}: linear-gradient(
    to top,
    #0d0d0d 0%,
    rgba(15, 15, 15, 0.2) 78.365%,
    rgba(15, 15, 15, 0) 100%
  );
  /* Painted over the 16:9 artwork, not over the whole shell. */
  ${COLOR.BANNER_DETAILS_HORIZONTAL_OVERLAY}: linear-gradient(
    to right,
    #0d0d0d 0%,
    rgba(13, 13, 13, 0.7) 36.552%,
    rgba(13, 13, 13, 0) 66.458%
  );
  ${COLOR.BANNER_SKELETON_BOTTOM_FADE}: linear-gradient(
    to bottom,
    rgba(20, 21, 21, 0) 0%,
    #141515 100%
  );
  ${COLOR.SKELETON_SHINE_GRADIENT}: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(190, 190, 190, 0.15) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  ${COLOR.LOGIN_VERTICAL_OVERLAY}: linear-gradient(
    360deg,
    #141515 70.01%,
    rgba(20, 21, 21, 0) 100%
  );
  ${COLOR.PLAYER_VERTICAL_OVERLAY}: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(0, 0, 0, 0) 52%,
    rgba(0, 0, 0, 0.75) 100%
  );
  ${COLOR.BANNER_PARTIAL_HORIZONTAL_OVERLAY}: linear-gradient(
    90deg,
    #0f0f0f 0%,
    rgba(15, 15, 15, 0.95) 8%,
    rgba(15, 15, 15, 0) 99.5%
  );
  ${COLOR.BACKGROUND_DARK}: #141515;
  // Color that can be customized via WBS
  ${COLOR.BACKGROUND_DARK_APP}: #141515;
  ${COLOR.BACKGROUND_GRAY}: #1d1d1d;
  ${COLOR.BACKGROUND_DARK_EPG}: #0a0a0a;
  ${COLOR.BACKGROUND_PROGRAM_CARD}: #0f0f0f;
  ${COLOR.BACKGROUND_VERTICAL_OVERLAY}: linear-gradient(
    0deg,
    #141515 0%,
    rgba(20, 21, 21, 0.83) 85.82%,
    rgba(20, 21, 21, 0.5) 95.36%
  );

  ${CORNERS.CORNERS_0}: 0px;
  ${CORNERS.CORNERS_5}: 2px;
  ${CORNERS.CORNERS_10}: 4px;
  ${CORNERS.CORNERS_20}: 8px;
  ${CORNERS.CORNERS_25}: 12px;
  ${CORNERS.CORNERS_30}: 16px;
  ${CORNERS.CORNERS_40}: 24px;
  ${CORNERS.CORNERS_50}: 32px;
  ${CORNERS.CORNERS_PILL}: 50px;
  ${CORNERS.CORNERS_LEFT_10}: 4px 0 0 4px;
  ${CORNERS.CORNERS_RIGHT_10}: 0 4px 4px 0;
  ${CORNERS.CORNERS_LEFT_TOP_10}: 4px 0 0 0;
  ${CORNERS.CORNERS_LEFT_25}: 12px 0 0 12px;
  ${CORNERS.CORNERS_RIGHT_25}: 0 12px 12px 0;
  ${CORNERS.CORNERS_LEFT_TOP_25}: 12px 0 0 0;
  ${CORNERS.CORNERS_RIGHT_BOTTOM_25}: 0 0 12px 0;
  ${CORNERS.CORNERS_ROUND}: 50%;
  ${CORNERS.CORNERS_BOTTOM_10}: 0 0 4px 4px;

  ${SHADOW.NORMAL}: 0 4px 10px 0 var(${COLOR.OVERLAY_DEFAULT});
  ${SHADOW.HUGE}: 0 4px 40px 0 var(${COLOR.OVERLAY_SHADOW});
  ${SHADOW.CARD}: 12px 12px 56px 0px var(${COLOR.OVERLAY_SHADOW});
  ${SHADOW.TOAST}: 0 0 60px 0 rgba(17, 17, 17, 0.7);

  ${FONT_FAMILY.MAIN}: 'Product Sans', sans-serif;

  ${BORDERS.BORDER_0}: 0px;
  ${BORDERS.BORDER_10}: 1px;
  ${BORDERS.BORDER_20}: 2px;
  ${BORDERS.BORDER_30}: 3px;

  ${ICONS_SIZES.SIZE_10}: 16px;
  ${ICONS_SIZES.SIZE_20}: 24px;
  ${ICONS_SIZES.SIZE_30}: 36px;
  ${ICONS_SIZES.SIZE_40}: 48px;
  ${ICONS_SIZES.SIZE_50}: 56px;

  ${PROGRESS_SIZES.SIZE_10}: 4px;
  ${PROGRESS_SIZES.SIZE_20}: 8px;
  ${PROGRESS_SIZES.SIZE_30}: 12px;
  ${PROGRESS_SIZES.SIZE_40}: 332px;

  ${INDENTS.INDENT_0}: 0px;
  ${INDENTS.INDENT_5}: 0.125em;
  ${INDENTS.INDENT_10}: 0.25em;
  ${INDENTS.INDENT_15}: 0.375em;
  ${INDENTS.INDENT_20}: 0.5em;
  ${INDENTS.INDENT_25}: 0.625em;
  ${INDENTS.INDENT_30}: 0.75em;
  ${INDENTS.INDENT_35}: 0.875em;
  ${INDENTS.INDENT_40}: 1em;
  ${INDENTS.INDENT_50}: 1.25em;
  ${INDENTS.INDENT_55}: 1.375em;
  ${INDENTS.INDENT_60}: 1.5em;
  ${INDENTS.INDENT_70}: 1.75em;
  ${INDENTS.INDENT_80}: 2em;
  ${INDENTS.INDENT_90}: 2.25em;
  ${INDENTS.INDENT_100}: 2.5em;
  ${INDENTS.INDENT_110}: 2.75em;
  ${INDENTS.INDENT_120}: 3em;
  ${INDENTS.INDENT_130}: 3.25em;
  ${INDENTS.INDENT_140}: 3.5em;
  ${INDENTS.INDENT_150}: 3.75em;
  ${INDENTS.INDENT_160}: 4em;
  ${INDENTS.INDENT_170}: 4.25em;
  ${INDENTS.INDENT_180}: 4.5em;

  ${LABEL_INDENTS.INDENT_10}: 16px;

  ${FIXED_INDENTS.INDENT_0}: 0px;
  ${FIXED_INDENTS.INDENT_5}: 2px;
  ${FIXED_INDENTS.INDENT_10}: 4px;
  ${FIXED_INDENTS.INDENT_20}: 8px;
  ${FIXED_INDENTS.INDENT_21}: 9px;
  ${FIXED_INDENTS.INDENT_25}: 10px;
  ${FIXED_INDENTS.INDENT_30}: 12px;
  ${FIXED_INDENTS.INDENT_40}: 16px;
  ${FIXED_INDENTS.INDENT_50}: 20px;
  ${FIXED_INDENTS.INDENT_55}: 22px;
  ${FIXED_INDENTS.INDENT_60}: 24px;
  ${FIXED_INDENTS.INDENT_70}: 28px;
  ${FIXED_INDENTS.INDENT_80}: 32px;
  ${FIXED_INDENTS.INDENT_90}: 36px;
  ${FIXED_INDENTS.INDENT_100}: 40px;
  ${FIXED_INDENTS.INDENT_110}: 44px;
  ${FIXED_INDENTS.INDENT_120}: 48px;
  ${FIXED_INDENTS.INDENT_130}: 52px;
  ${FIXED_INDENTS.INDENT_140}: 56px;
  ${FIXED_INDENTS.INDENT_150}: 60px;
  ${FIXED_INDENTS.INDENT_160}: 64px;
  ${FIXED_INDENTS.INDENT_170}: 68px;
  ${FIXED_INDENTS.INDENT_180}: 72px;
  ${FIXED_INDENTS.INDENT_190}: 76px;
  ${FIXED_INDENTS.INDENT_200}: 80px;
  ${FIXED_INDENTS.INDENT_210}: 84px;
  ${FIXED_INDENTS.INDENT_220}: 88px;
  ${FIXED_INDENTS.INDENT_230}: 92px;
  ${FIXED_INDENTS.INDENT_240}: 96px;
  ${FIXED_INDENTS.INDENT_250}: 100px;
  ${FIXED_INDENTS.INDENT_260}: 104px;
  ${FIXED_INDENTS.INDENT_270}: 108px;
  ${FIXED_INDENTS.INDENT_280}: 112px;
  ${FIXED_INDENTS.INDENT_290}: 116px;
  ${FIXED_INDENTS.INDENT_300}: 120px;
  ${FIXED_INDENTS.INDENT_310}: 124px;
  ${FIXED_INDENTS.INDENT_320}: 128px;
  ${FIXED_INDENTS.INDENT_330}: 132px;
  ${FIXED_INDENTS.INDENT_340}: 136px;
  ${FIXED_INDENTS.INDENT_350}: 140px;
  ${FIXED_INDENTS.INDENT_360}: 144px;
  ${FIXED_INDENTS.INDENT_370}: 148px;
  ${FIXED_INDENTS.INDENT_380}: 152px;
  ${FIXED_INDENTS.INDENT_390}: 156px;
  ${FIXED_INDENTS.INDENT_400}: 160px;
  ${FIXED_INDENTS.INDENT_410}: 164px;
  ${FIXED_INDENTS.INDENT_420}: 168px;
  ${FIXED_INDENTS.INDENT_430}: 172px;
  ${FIXED_INDENTS.INDENT_440}: 176px;
  ${FIXED_INDENTS.INDENT_450}: 180px;
  ${FIXED_INDENTS.INDENT_460}: 184px;
  ${FIXED_INDENTS.INDENT_470}: 188px;
  ${FIXED_INDENTS.INDENT_480}: 192px;

  ${COLLECTION_GAPS.ROW_GAP_DEFAULT}: 1rem;
  ${COLLECTION_GAPS.ROW_HORIZONTAL_PADDINGS_DEFAULT}: 3.5rem;
  ${COLLECTION_GAPS.GRID_GAP_HORIZONTAL}: 0.5rem;
  ${COLLECTION_GAPS.GRID_GAP_VERTICAL}: 0.5rem;
  ${COLLECTION_GAPS.GRID_GAP_SEARCH_VERTICAL}: 0.75rem;
  ${COLLECTION_GAPS.GRID_GAP_SEARCH_HORIZONTAL}: 0.75rem;

  ${TRANSITIONS.LINEAR_400}: 400ms linear;
  ${TRANSITIONS.LINEAR_300}: 300ms linear;
  ${TRANSITIONS.LINEAR_200}: 200ms linear;
  ${TRANSITIONS.LINEAR_150}: 150ms linear;
  ${TRANSITIONS.LINEAR_100}: 100ms linear;
  ${TRANSITIONS.PLAYER_DEFAULT}: 250ms ease-in;

  ${NAVBAR_HEIGHT.DEFAULT}: 56px;

  ${FONTS.Font5xl}: 3rem/1.25 var(${FONT_FAMILY.MAIN});
  ${FONTS.Font5xlBold}: bold var(${FONTS.Font5xl});
  ${FONTS.Font4xl}: 2.75rem/1.273 var(${FONT_FAMILY.MAIN});
  ${FONTS.Font4xlBold}: bold var(${FONTS.Font4xl});
  ${FONTS.Font3xl}: 2.25rem/1.278 var(${FONT_FAMILY.MAIN});
  ${FONTS.Font3xlBold}: bold var(${FONTS.Font3xl});
  ${FONTS.Font2xl}: 1.75rem/1.429 var(${FONT_FAMILY.MAIN});
  ${FONTS.Font2xlBold}: bold var(${FONTS.Font2xl});
  ${FONTS.FontXl}: 1.5rem/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.FontXlBold}: bold var(${FONTS.FontXl});
  ${FONTS.FontLg}: 1.25rem/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.FontLgBold}: bold var(${FONTS.FontLg});
  ${FONTS.FontSm}: 1rem/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.FontSmBold}: bold var(${FONTS.FontSm});
  ${FONTS.FontMdToSm}: 1.125rem/1.333 var(${FONT_FAMILY.MAIN});
  ${FONTS.FontMdToSmBold}: bold var(${FONTS.FontMdToSm});
  ${FONTS.FontXs}: 0.875rem/1.429 var(${FONT_FAMILY.MAIN});
  ${FONTS.FontXsBold}: bold var(${FONTS.FontXs});

  ${FONTS.HeadlineExtra5}: bold 2.5em/1.4 var(${FONT_FAMILY.MAIN});
  ${FONTS.HeadlineExtra10}: bold 2em/1.375 var(${FONT_FAMILY.MAIN});
  ${FONTS.Headline1}: bold 1.25em/1.6 var(${FONT_FAMILY.MAIN});
  ${FONTS.Headline2}: bold 1.125em/1.37 var(${FONT_FAMILY.MAIN});
  ${FONTS.Headline3}: bold 1.125em/1.78 var(${FONT_FAMILY.MAIN});
  ${FONTS.Headline4}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Footnote1}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Footnote2}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Footnote3}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Footnote4}: bold 0.875em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Footnote5}: bold 0.875em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Footnote6}: bold 0.75em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Body1}: 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Body2}: 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Body3}: 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Body4}: 0.875em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Body5}: 0.75em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Caption1}: 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Caption2}: 0.875em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Caption3}: 0.875em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Caption4}: 0.75em/1.83 var(${FONT_FAMILY.MAIN});
  ${FONTS.Caption5}: 0.625em/1.8 var(${FONT_FAMILY.MAIN});
  ${FONTS.Button1}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
  ${FONTS.Button2}: bold 0.875em/1.71 var(${FONT_FAMILY.MAIN});
  ${FONTS.Button3}: bold 1em/1.25 var(${FONT_FAMILY.MAIN});

  ${LAYOUT.HorizontalPaddings}: 1rem;
  ${LAYOUT.VerticalPaddings}: 1.75rem;
  ${LAYOUT.VerticalGridPaddings}: 4rem;
  ${LAYOUT.VerticalGridTitlePaddings}: 0.75rem;
  ${LAYOUT.VerticalGridTitleCategoryPaddings}: 1.75rem;

  ${LAYOUT.VerticalRowPaddings}: 1.5rem;
  ${LAYOUT.VerticalBottomRowPaddings}: 0.75rem;
  ${LAYOUT.VerticalBottomSpecialRowPaddings}: 0.75rem;
  ${LAYOUT.VerticalTopRowPaddings}: 0.75rem;
  ${LAYOUT.VerticalTopSpecialRowPaddings}: 0.75rem;
  ${LAYOUT.VerticalCardsCategoryPaddings}: 8px;
  ${LAYOUT.LoaderHeight}: 4px;
  ${LAYOUT.VerticalBottomSpecialSimpleRowPaddings}: 0.75rem;
  ${LAYOUT.VerticalTopSpecialSimpleRowPaddings}: 0.75rem;

  ${LAYOUT.NavbarSize}: 3.5rem;

  ${LAYOUT.DetailsPageVerticalGridTopOffset}: 32px;

  ${GRID.VerticalPaddingsDetailsPage}: 12px;
  ${GRID.VerticalPaddingsSearchPage}: 24px;
  ${GRID.VerticalPaddingsGridMotn}: 20px;
  ${GRID.VerticalPaddingsLoaderMotn}: 24px;
  ${GRID.VerticalGapBetweenTitleAndGrid}: 8px;

  // FP-4260: the recommendations grid of the content details page, read off
  // the Figma details -> Grid frames (16284:251298 / 251297 / 251296 /
  // 251295 / 249978 at 375 / 600 / 1024 / 1240 / 1920). Neither cutoff the
  // design leaves open is invented: the gaps step at the only stop between
  // 600 and 1024 (768), the horizontal padding at the only stop between 1240
  // and 1920 (1640).
  ${GRID.VerticalPaddingsDetailsRecommendations}: var(
    ${FIXED_INDENTS.INDENT_50}
  );
  ${GRID.HorizontalPaddingsDetailsRecommendations}: var(
    ${FIXED_INDENTS.INDENT_40}
  );
  ${GRID.TitleGapDetailsRecommendations}: var(${FIXED_INDENTS.INDENT_20});
  ${GRID.GapDetailsRecommendations}: var(${FIXED_INDENTS.INDENT_20});

  // FP-4261 / FP-4324: the episodes row of the series details page, read off
  // the Figma series frames at 375 (16273:216762) and 1920 (16273:212314).
  // Horizontal padding follows the same ladder the details area already uses
  // on this page. Top / bottom / gap start at the 375 values (16 / 24 / 8).
  // The season-description-to-cards gap is this top padding alone — the row
  // opts into RowWithoutHeader so containerVerticalGap does not add 20px.
  ${GRID.PaddingTopDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_40});
  ${GRID.PaddingBottomDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_60});
  ${GRID.HorizontalPaddingsDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_40});
  ${GRID.GapDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_20});

  ${InputActionButtonIndentAdaptive.SIZE_10}: 16px;
  ${InputPaddingsAdaptive.SIZE_10}: 12px 48px;
  ${InputHeight.SIZE_10}: 56px;
  ${InputHeight.SIZE_20}: 48px;
  ${InputHeight.SIZE_30}: 40px;
  ${BANNER_PADDINGS.SIZE_10}: 64px 16px;
  ${BANNER_PADDINGS.SIZE_20}: 64px 16px;
  ${BANNER_PADDINGS.SIZE_30}: 64px 16px;
  ${BANNER_PADDINGS.SIZE_40}: 24px 16px;
  ${BANNER_PADDINGS.SIZE_50}: 56px 16px;
  ${BANNER_PADDINGS.SIZE_60}: 56px 16px;
  ${BANNER_PADDINGS.DETAILS_PAGE}: 56px var(${LAYOUT.HorizontalPaddings});
  ${BANNER_PADDINGS.PARTNER_PROGRAM_DETAILS_PAGE}: 16px 16px 32px 16px;
  ${LABEL_PADDINGS.SIZE_10}: 7px 16px;
  ${LABEL_PADDINGS.SIZE_20}: 4px 16px;
  ${LABEL_PADDINGS.SIZE_30}: 4px 12px;
  ${LABEL_PADDINGS.SIZE_40}: 8px 16px;
  ${LABEL_PADDINGS.SIZE_50}: 6px 12px;

  ${BUTTON_PADDINGS.SIZE_10}: 12px 16px;
  ${BUTTON_PADDINGS.SIZE_20}: 8px 16px;

  ${BANNER_DESCRIPTION_WIDTH.SIZE_10}: 100%;
  ${BANNER_DESCRIPTION_WIDTH.SIZE_20}: 100%;
  ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 100%;
  ${BANNER_DESCRIPTION_WIDTH.SIZE_40}: 100%;
  ${BANNER_DESCRIPTION_WIDTH.SIZE_50}: 100%;
  ${BANNER_DESCRIPTION_WIDTH.SIZE_60}: 100%;
  ${BANNER_WIDTH.SIZE_100}: 100%;
  ${BANNER_WIDTH.SIZE_94}: 100%;
  ${BANNER_WIDTH.SIZE_66}: 100%;
  ${BANNER_ASPECT_RATIO.POSTER}: 0.665;
  ${BANNER_ASPECT_RATIO.SKELETON_DEFAULT}: 2.2;
  ${BANNER_ASPECT_RATIO.SIZE_10}: 0.665;
  ${BANNER_ASPECT_RATIO.SIZE_20}: 0.665;
  ${BANNER_ASPECT_RATIO.SIZE_30}: 0.665;
  ${BANNER_ASPECT_RATIO.SIZE_40}: 0.665;
  ${BANNER_ASPECT_RATIO.SIZE_50}: 1.78;
  ${BANNER_ASPECT_RATIO.DETAILS_BANNER}: 0.6667;
  ${BANNER_HEIGHT.DETAILS_BANNER_COMPACT}: 0px;
  ${BANNER_ASPECT_RATIO.LIVE_EVENTS_BANNER}: 0.66;
  ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.11;
  ${BANNER_ASPECT_RATIO.PARTNER_PRODUCT_BANNER}: 0.67;
  ${BANNER_BACK_BUTTON_INDENT.SIZE_20}: 24px;
  ${ROW_GAP.SIZE_10}: 8px;
  ${ROW_GAP.SIZE_20}: 4px;
  ${ROW_GAP.SIZE_30}: 12px;
  ${MULTI_COLUMN_GAP.SIZE_10}: 16px;
  ${DESCRIPTION_PADDINGS.SIZE_10}: 12px 0 8px;
  ${DESCRIPTION_PADDINGS.SIZE_20}: 8px 0 36px;
  ${DESCRIPTION_PADDINGS.SIZE_30}: 36px 0 0px;
  ${DESCRIPTION_PADDINGS.SIZE_40}: 56px;
  ${BRAND_PADDINGS.SIZE_10}: 12px 8px 12px 0;
  ${LAYOUT_BLOCK_PADDINGS.SIZE_20}: 24px 16px 4px;
  ${LAYOUT_BLOCK_PADDINGS.SIZE_30}: 88px 16px 16px;
  ${LAYOUT_BLOCK_PADDINGS.SIZE_40}: 24px 16px 0;
  ${LAYOUT_BLOCK_PADDINGS.SIZE_50}: 8px 16px 0;
  ${CAROUSEL_PADDINGS.PADDING_TOP_SPECIAL_ROW}: 56px;
  ${CAROUSEL_PADDINGS.VERTICAL_PADDINGS_EPISODES_ROW_DETAILS_PAGE}: 24px;

  ${ROW_CONTAINER_VERTICAL_GAPS.RowWithoutHeader}: 0px;
  ${ROW_CONTAINER_VERTICAL_GAPS.RowDefault}: 8px;
  ${ROW_CONTAINER_VERTICAL_GAPS.SpecialRowWithHeaderDefault}: 24px;

  ${MC_PADDINGS.MC_TVSHOW_DETAILS_PAGE_EPISODES}: 24px
    var(${LAYOUT.HorizontalPaddings}) 28px;

  ${EPG_SIDEBAR_SKELETON_SIZES.CHANNEL_TITLE_SKELETON_HEIGHT}: 32px;
  ${EPG_SIDEBAR_SKELETON_SIZES.CHANNEL_TITLE_SKELETON_WIDTH}: 64px;
  ${EPG_SIDEBAR_SKELETON_SIZES.LABEL_GROUP_SKELETON_HEIGHT}: 22px;
  ${EPG_SIDEBAR_SKELETON_SIZES.LABEL_GROUP_SKELETON_WIDTH}: 33px;
  ${EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_TITLE_SKELETON_HEIGHT}: 44px;
  ${EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_TITLE_SKELETON_WIDTH}: 55%;
  ${EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_DESCRIPTION_SKELETON_HEIGHT}: 192px;
  ${EPG_SIDEBAR_SKELETON_SIZES.PROGRAM_DESCRIPTION_SKELETON_WIDTH}: 80%;
  ${PLAYER_LAYOUT.PlayerHorizontalPaddingsDefault}: 1rem;
  ${PLAYER_LAYOUT.PlayerVerticalPaddingsDefault}: 1rem;
  ${PLAYER_LAYOUT.PlayerHorizontalPaddingsSize10}: 0.5rem;
  ${PLAYER_LAYOUT.PlayerVerticalPaddingsSize10}: 0.5rem;
  ${PLAYER_PROGRESS.PLAYER_PROGRESS_INDENT_DEFAULT}: 16px;
  ${PLAYER_BUTTON_SIZES.SIZE_10}: 50px;
  ${PLAYER_BUTTON_SIZES.SIZE_20}: 88px;

  ${MC_PADDINGS.MC_TVSHOW_DETAILS_PAGE_EPISODES}: 24px
    var(${LAYOUT.HorizontalPaddings}) 28px;

  ${PopupLayout.horizontalPaddings}: var(${FIXED_INDENTS.INDENT_140});
  ${PopupLayout.headerBottomPadding}: var(${FIXED_INDENTS.INDENT_60});
  ${PopupLayout.motnHorizontalPaddings}: var(${FIXED_INDENTS.INDENT_60});
  ${PopupLayout.motnHeaderBottomPadding}: var(${FIXED_INDENTS.INDENT_50});

  ${NoContentIconSizes.DEFAULT}: 5rem;

  ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 0.9;
  ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL}: 1.64;
  ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.536;
  ${EVENT_CARD_ASPECT_RATIO.HORIZONTAL_DEFAULT}: 1.267;

  ${TEXT_SHADOW.RAISED}: 1.603px 1.196px 0 #000,
    1.388px 1.036px 0 rgba(0, 0, 0, 0.83),
    1.121px 0.837px 0 rgba(0, 0, 0, 0.75),
    0.831px 0.621px 0 rgba(0, 0, 0, 0.72),
    0.546px 0.408px 0 rgba(0, 0, 0, 0.7),
    0.292px 0.218px 0 rgba(0, 0, 0, 0.65),
    0.098px 0.073px 0 rgba(0, 0, 0, 0.55),
    -0.008px -0.006px 0 rgba(0, 0, 0, 0.34);
  ${TEXT_SHADOW.DEPRESSED}: -0.3px -0.3px 0 #000,
    0.3px 0.3px 0 #c0c0c0;
  ${TEXT_SHADOW.DROP_SHADOW}: 1.5px 1.5px 2px rgba(0, 0, 0, 0.5);

  ${MEDIA.MIN_600} {
    ${FONTS.Font5xl}: 3.25rem/1.269 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font5xlBold}: bold var(${FONTS.Font5xl});
    ${FONTS.Font4xl}: 3rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font4xlBold}: bold var(${FONTS.Font4xl});
    ${FONTS.Font3xl}: 2.5rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font3xlBold}: bold var(${FONTS.Font3xl});
    ${FONTS.Font2xl}: 2rem/1.3125 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font2xlBold}: bold var(${FONTS.Font2xl});
    ${FONTS.FontXl}: 1.5rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXlBold}: bold var(${FONTS.FontXl});
    ${FONTS.FontLg}: 1.25rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontLgBold}: bold var(${FONTS.FontLg});
    ${FONTS.FontSm}: 1rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontSmBold}: bold var(${FONTS.FontSm});
    ${FONTS.FontXs}: 0.875rem/1.429 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXsBold}: bold var(${FONTS.FontXs});
    ${FONTS.Footnote4}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});

    ${BANNER_ASPECT_RATIO.POSTER}: 1.78;

    ${ROW_GAP.SIZE_30}: 16px;

    ${InputActionButtonIndentAdaptive.SIZE_10}: 24px;
    ${InputPaddingsAdaptive.SIZE_10}: 16px 60px;
    ${InputHeight.SIZE_20}: 56px;
    ${BANNER_PADDINGS.SIZE_10}: 48px 16px;
    ${BANNER_PADDINGS.SIZE_20}: 48px 16px;
    ${BANNER_PADDINGS.SIZE_30}: 48px 16px;
    ${BANNER_PADDINGS.SIZE_40}: 24px 24px;
    ${BANNER_PADDINGS.SIZE_50}: 12px 16px;
    ${BANNER_PADDINGS.DETAILS_PAGE}: 18px var(${LAYOUT.HorizontalPaddings});

    ${BANNER_DESCRIPTION_WIDTH.SIZE_10}: 62%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_20}: 62%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 62%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_40}: 62%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_50}: 90%;
    ${BANNER_ASPECT_RATIO.SIZE_10}: 1.77;
    ${BANNER_ASPECT_RATIO.SIZE_20}: 1.77;
    ${BANNER_ASPECT_RATIO.SIZE_30}: 1.77;
    ${BANNER_ASPECT_RATIO.SIZE_40}: 1.77;
    ${BANNER_ASPECT_RATIO.DETAILS_BANNER}: 1.7778;
    /* 600×580 Figma shell; the 16:9 ratio alone is only 337.5px at 600. */
    ${BANNER_HEIGHT.DETAILS_BANNER_COMPACT}: 580px;
    ${BANNER_ASPECT_RATIO.LIVE_EVENTS_BANNER}: 1.77;
    ${LAYOUT.VerticalCardsCategoryPaddings}: 12px;
    ${LAYOUT.VerticalGridTitlePaddings}: 1rem;
    ${CAROUSEL_PADDINGS.PADDING_TOP_SPECIAL_ROW}: 56px;
    ${PLAYER_LAYOUT.PlayerHorizontalPaddingsSize10}: 1rem;
    ${PLAYER_LAYOUT.PlayerVerticalPaddingsSize10}: 1rem;
    ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.22;
    ${LAYOUT.VerticalBottomRowPaddings}: 0.75rem;
    ${LAYOUT.VerticalTopRowPaddings}: 0.75rem;

    ${BUTTON_PADDINGS.SIZE_10}: 12px 20px;
    ${BUTTON_PADDINGS.SIZE_20}: 12px 20px;

    ${LABEL_INDENTS.INDENT_10}: 20px;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 0.89;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL}: 1.693;
    ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.526;
    ${EVENT_CARD_ASPECT_RATIO.HORIZONTAL_DEFAULT}: 1.308;

    ${PopupLayout.motnHeaderBottomPadding}: var(${FIXED_INDENTS.INDENT_60});
    ${GRID.VerticalPaddingsGridMotn}: 24px;
    ${GRID.VerticalPaddingsLoaderMotn}: 24px;
    ${GRID.VerticalPaddingsDetailsRecommendations}: var(
      ${FIXED_INDENTS.INDENT_60}
    );
    ${GRID.HorizontalPaddingsDetailsRecommendations}: var(
      ${FIXED_INDENTS.INDENT_80}
    );
    ${GRID.HorizontalPaddingsDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_80});
    ${GRID.PaddingTopDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_50});
    ${GRID.GapDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_30});
  }

  ${MEDIA.MIN_768} {
    ${GRID.TitleGapDetailsRecommendations}: var(${FIXED_INDENTS.INDENT_50});
    ${GRID.GapDetailsRecommendations}: var(${FIXED_INDENTS.INDENT_40});
    ${BANNER_PADDINGS.SIZE_50}: 38px 16px;
    ${BANNER_PADDINGS.DETAILS_PAGE}: 44px var(${LAYOUT.HorizontalPaddings});
    ${BANNER_DESCRIPTION_WIDTH.SIZE_10}: 48%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_20}: 48%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 48%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_40}: 48%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_50}: 69%;
    ${CAROUSEL_PADDINGS.PADDING_TOP_SPECIAL_ROW}: 62px;
    ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.26;
    ${LAYOUT.VerticalBottomRowPaddings}: 0.75rem;
    ${LAYOUT.VerticalTopRowPaddings}: 0.75rem;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 0.943;
    ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.557;
  }

  ${MEDIA.MIN_1024} {
    /* 1024×576 is already 16:9 from DETAILS_BANNER; drop the 600px floor. */
    ${BANNER_HEIGHT.DETAILS_BANNER_COMPACT}: 0px;
  }

  ${MEDIA.MIN_1240} {
    ${FONTS.Font5xl}: 3.5rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font5xlBold}: bold var(${FONTS.Font5xl});
    ${FONTS.Font4xl}: 3.25rem/1.269 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font4xlBold}: bold var(${FONTS.Font4xl});
    ${FONTS.Font3xl}: 2.75rem/1.273 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font3xlBold}: bold var(${FONTS.Font3xl});
    ${FONTS.Font2xl}: 2.25rem/1.278 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font2xlBold}: bold var(${FONTS.Font2xl});
    ${FONTS.FontXl}: 1.75rem/1.429 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXlBold}: bold var(${FONTS.FontXl});
    ${FONTS.FontLg}: 1.5rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontLgBold}: bold var(${FONTS.FontLg});
    ${FONTS.FontSm}: 1rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontSmBold}: bold var(${FONTS.FontSm});
    ${FONTS.FontXs}: 0.875rem/1.429 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXsBold}: bold var(${FONTS.FontXs});

    ${FONTS.HeadlineExtra5}: bold 5em/1.2 var(${FONT_FAMILY.MAIN});
    ${FONTS.HeadlineExtra10}: bold 3.75em/1.2 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline1}: bold 2.5em/1.4 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline2}: bold 2em/1.375 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline3}: bold 1.5em/1.33 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline4}: bold 1.25em/1.6 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote1}: bold 1.75em/1.43 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote2}: bold 1.5em/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote3}: bold 1.25em/1.6 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote4}: bold 1.125em/1.78 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote5}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote6}: bold 0.875em/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body1}: 1.25em/1.4 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body2}: 1.175em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body3}: 1em/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body4}: 0.875em/1.71 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body5}: 0.75em/1.71 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption1}: 1.125em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption2}: 1em/1.75 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption3}: 0.875em/1.71 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption4}: 0.75em/1.83 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption5}: 0.625em/1.8 var(${FONT_FAMILY.MAIN});
    ${FONTS.Button1}: bold 1em/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.Button2}: bold 0.875em/1.71 var(${FONT_FAMILY.MAIN});
    ${BANNER_PADDINGS.SIZE_10}: 88px 136px;
    ${BANNER_PADDINGS.SIZE_20}: 56px 56px;
    ${BANNER_PADDINGS.SIZE_30}: 80px 88px;
    ${BANNER_PADDINGS.SIZE_40}: 88px 136px;
    ${BANNER_PADDINGS.SIZE_50}: 56px 56px;
    ${BANNER_PADDINGS.SIZE_60}: 56px 56px;
    ${BANNER_PADDINGS.DETAILS_PAGE}: 56px var(${LAYOUT.HorizontalPaddings});

    ${BANNER_DESCRIPTION_WIDTH.SIZE_10}: 56%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_20}: 67%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 57%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_40}: 56%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_50}: 100%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_60}: 586px;
    ${BANNER_WIDTH.SIZE_94}: 91%;
    ${BANNER_ASPECT_RATIO.SIZE_30}: 2.68;
    ${BANNER_WIDTH.SIZE_66}: 66%;
    ${BANNER_ASPECT_RATIO.SIZE_10}: 2.433;
    ${BANNER_ASPECT_RATIO.SIZE_20}: 1.78;
    ${BANNER_ASPECT_RATIO.DETAILS_BANNER}: 2.0235;
    ${BANNER_WIDTH.SIZE_66}: 66.1%;
    ${BANNER_ASPECT_RATIO.SIZE_40}: 2.69;
    ${BANNER_ASPECT_RATIO.LIVE_EVENTS_BANNER}: 2.2;
    ${BANNER_BACK_BUTTON_INDENT.SIZE_20}: 40px;
    ${LAYOUT.VerticalPaddings}: 3.5rem;
    ${LAYOUT.VerticalPageTitlePaddings}: 1.75rem;
    ${LAYOUT.VerticalGridPaddings}: 5.5rem;
    ${LAYOUT.VerticalGridTitleCategoryPaddings}: 3.5rem;
    ${LAYOUT.VerticalRowPaddings}: 3.5rem;
    ${LAYOUT.VerticalBottomRowPaddings}: 1.75rem;
    ${LAYOUT.VerticalBottomSpecialRowPaddings}: 0;
    ${LAYOUT.VerticalTopRowPaddings}: 1.75rem;
    ${LAYOUT.VerticalTopSpecialRowPaddings}: 0;
    ${LAYOUT.HorizontalPaddings}: 3.5rem;
    ${LAYOUT.VerticalBottomSpecialSimpleRowPaddings}: 1.75rem;
    ${LAYOUT.VerticalTopSpecialSimpleRowPaddings}: 1.75rem;

    ${GRID.VerticalPaddingsDetailsPage}: 20px;
    ${GRID.VerticalPaddingsSearchPage}: 40px;
    ${GRID.VerticalPaddingsDetailsPage}: 28px;
    ${GRID.VerticalPaddingsDetailsRecommendations}: var(
      ${FIXED_INDENTS.INDENT_80}
    );
    ${GRID.HorizontalPaddingsDetailsRecommendations}: var(
      ${FIXED_INDENTS.INDENT_160}
    );
    ${GRID.HorizontalPaddingsDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_160});

    ${LAYOUT.DetailsPageVerticalGridTopOffset}: 0px;

    ${ROW_GAP.SIZE_10}: 16px;
    ${MULTI_COLUMN_GAP.SIZE_10}: 24px;
    ${DESCRIPTION_PADDINGS.SIZE_10}: 20px 0 8px;
    ${BRAND_PADDINGS.SIZE_10}: 14px 16px 14px 0;
    ${LAYOUT_BLOCK_PADDINGS.SIZE_20}: 28px 56px 8px;
    ${LAYOUT_BLOCK_PADDINGS.SIZE_30}: 88px 56px 56px;
    ${LAYOUT_BLOCK_PADDINGS.SIZE_40}: 28px 56px 0;
    ${LAYOUT_BLOCK_PADDINGS.SIZE_50}: 8px 56px 0;
    ${CAROUSEL_PADDINGS.PADDING_TOP_SPECIAL_ROW}: 96px;
    ${CAROUSEL_PADDINGS.VERTICAL_PADDINGS_EPISODES_ROW_DETAILS_PAGE}: 28px;

    ${ROW_CONTAINER_VERTICAL_GAPS.RowDefault}: 20px;
    ${PLAYER_LAYOUT.PlayerHorizontalPaddingsDefault}: 3.5rem;
    ${PLAYER_LAYOUT.PlayerVerticalPaddingsDefault}: 2.5rem;
    ${PLAYER_PROGRESS.PLAYER_PROGRESS_INDENT_DEFAULT}: 24px;
    ${PLAYER_BUTTON_SIZES.SIZE_20}: 104px;

    ${MC_PADDINGS.MC_TVSHOW_DETAILS_PAGE_EPISODES}: 28px
      var(${LAYOUT.HorizontalPaddings}) 32px;
    ${COLLECTION_GAPS.GRID_GAP_HORIZONTAL}: 1rem;
    ${COLLECTION_GAPS.GRID_GAP_VERTICAL}: 1rem;
    ${COLLECTION_GAPS.GRID_GAP_SEARCH_VERTICAL}: 1rem;
    ${NoContentIconSizes.DEFAULT}: 7.5rem;
    ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.3;
    ${BANNER_ASPECT_RATIO.PARTNER_PRODUCT_BANNER}: 1.53;
    ${BANNER_PADDINGS.PARTNER_PROGRAM_DETAILS_PAGE}: 16px 56px 56px 56px;
    ${LABEL_PADDINGS.SIZE_10}: 8px 20px;

    ${BUTTON_PADDINGS.SIZE_10}: 12px 24px;
    ${BUTTON_PADDINGS.SIZE_20}: 12px 24px;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 0.966;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL}: 1.816;
    ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.57;
    ${EVENT_CARD_ASPECT_RATIO.HORIZONTAL_DEFAULT}: 1.403;

    ${PopupLayout.motnHorizontalPaddings}: var(${FIXED_INDENTS.INDENT_100});
    ${PopupLayout.motnHeaderBottomPadding}: var(${FIXED_INDENTS.INDENT_80});
    ${GRID.VerticalPaddingsGridMotn}: 32px;
    ${GRID.VerticalPaddingsLoaderMotn}: 40px;
  }

  ${MEDIA.MIN_1440} {
    ${FONTS.Font5xl}: 3.5rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font5xlBold}: bold var(${FONTS.Font5xl});
    ${FONTS.Font4xl}: 3.25rem/1.269 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font4xlBold}: bold var(${FONTS.Font4xl});
    ${FONTS.Font3xl}: 2.75rem/1.273 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font3xlBold}: bold var(${FONTS.Font3xl});
    ${FONTS.Font2xl}: 2.25rem/1.278 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font2xlBold}: bold var(${FONTS.Font2xl});
    ${FONTS.FontXl}: 1.75rem/1.429 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXlBold}: bold var(${FONTS.FontXl});
    ${FONTS.FontLg}: 1.5rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontLgBold}: bold var(${FONTS.FontLg});
    ${FONTS.FontSm}: 1rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontSmBold}: bold var(${FONTS.FontSm});
    ${FONTS.FontXs}: 0.875rem/1.429 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXsBold}: bold var(${FONTS.FontXs});

    ${BANNER_PADDINGS.SIZE_10}: 145px 88px;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_10}: 43%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_20}: 66%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 47%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_40}: 47%;
    ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.36;
    ${BANNER_ASPECT_RATIO.PARTNER_PRODUCT_BANNER}: 1.78;
    ${BANNER_PADDINGS.PARTNER_PROGRAM_DETAILS_PAGE}: 56px;
    ${BANNER_WIDTH.SIZE_94}: 92.23%;
    ${BANNER_ASPECT_RATIO.SIZE_30}: 2.64;
    ${BANNER_WIDTH.SIZE_66}: 65.6%;
    ${BANNER_ASPECT_RATIO.SIZE_40}: 2.71;
    ${LABEL_PADDINGS.SIZE_10}: 8px 20px;

    ${LABEL_INDENTS.INDENT_10}: 24px;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 0.989;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL}: 1.88;
    ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.584;
    ${EVENT_CARD_ASPECT_RATIO.HORIZONTAL_DEFAULT}: 1.45;
    ${GRID.PaddingTopDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_60});
    ${GRID.PaddingBottomDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_100});
  }

  ${MEDIA.MIN_1640} {
    ${FONTS.Font5xl}: 4rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font5xlBold}: bold var(${FONTS.Font5xl});
    ${FONTS.Font4xl}: 3.5rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font4xlBold}: bold var(${FONTS.Font4xl});
    ${FONTS.Font3xl}: 3rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font3xlBold}: bold var(${FONTS.Font3xl});
    ${FONTS.Font2xl}: 2.5rem/1.25 var(${FONT_FAMILY.MAIN});
    ${FONTS.Font2xlBold}: bold var(${FONTS.Font2xl});
    ${FONTS.FontXl}: 2rem/1.3125 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXlBold}: bold var(${FONTS.FontXl});
    ${FONTS.FontLg}: 1.5rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontLgBold}: bold var(${FONTS.FontLg});
    ${FONTS.FontSm}: 1rem/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontSmBold}: bold var(${FONTS.FontSm});
    ${FONTS.FontXs}: 0.875rem/1.429 var(${FONT_FAMILY.MAIN});
    ${FONTS.FontXsBold}: bold var(${FONTS.FontXs});

    ${FONTS.HeadlineExtra5}: bold 5.875em/1.2 var(${FONT_FAMILY.MAIN});
    ${FONTS.HeadlineExtra10}: bold 4.375em/1.2 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline1}: bold 3em/1.375 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline2}: bold 2.375em/1.37 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline3}: bold 1.75em/1.35 var(${FONT_FAMILY.MAIN});
    ${FONTS.Headline4}: bold 1.5em/1.6 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote1}: bold 2.125em/1.41 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote2}: bold 1.75em/1.5 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote3}: bold 1.5em/1.58 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote4}: bold 1.375em/1.73 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote5}: bold 1.125em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Footnote6}: bold 1em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body1}: 1.5em/1.42 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body2}: 1.375em/1.55 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body3}: 1.125em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body4}: 1em/1.75 var(${FONT_FAMILY.MAIN});
    ${FONTS.Body5}: 0.875em/1.75 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption1}: 1.375em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption2}: 1.125em/1.89 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption3}: 1em/1.75 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption4}: 0.875em/1.86 var(${FONT_FAMILY.MAIN});
    ${FONTS.Caption5}: 0.75em/1.83 var(${FONT_FAMILY.MAIN});
    ${FONTS.Button1}: bold 1.125em/1.56 var(${FONT_FAMILY.MAIN});
    ${FONTS.Button2}: bold 1em/1.75 var(${FONT_FAMILY.MAIN});
    ${BANNER_PADDINGS.SIZE_10}: 88px 136px;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_10}: 47%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_20}: 66%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 40%;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_40}: 47%;
    ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.31;
    ${BANNER_WIDTH.SIZE_94}: 93.16%;
    ${BANNER_ASPECT_RATIO.SIZE_30}: 2.61;
    ${BANNER_WIDTH.SIZE_66}: 61.7%;
    ${BANNER_ASPECT_RATIO.SIZE_40}: 2.88;
    ${BANNER_ASPECT_RATIO.DETAILS_BANNER}: 2.3704;
    ${COLOR.BANNER_DETAILS_HORIZONTAL_OVERLAY}: linear-gradient(
      to right,
      #0d0d0d 0%,
      rgba(13, 13, 13, 0.7) 42.958%,
      rgba(13, 13, 13, 0) 77.743%
    );
    ${LABEL_PADDINGS.SIZE_10}: 10px 22px;
    ${LABEL_PADDINGS.SIZE_20}: 4px 20px;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 0.985;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL}: 1.822;
    ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.58;
    ${EVENT_CARD_ASPECT_RATIO.HORIZONTAL_DEFAULT}: 1.408;

    ${PopupLayout.motnHorizontalPaddings}: var(${FIXED_INDENTS.INDENT_120});
    ${GRID.VerticalPaddingsLoaderMotn}: 48px;
    ${GRID.HorizontalPaddingsDetailsRecommendations}: var(
      ${FIXED_INDENTS.INDENT_200}
    );
    ${GRID.HorizontalPaddingsDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_200});
  }

  ${MEDIA.MIN_1920} {
    ${BANNER_PADDINGS.SIZE_20}: 130px 56px;
    ${BANNER_PADDINGS.SIZE_30}: 226px 88px;
    ${BANNER_PADDINGS.SIZE_50}: 192px 56px;
    ${BANNER_DESCRIPTION_WIDTH.SIZE_30}: 48%;
    ${MULTI_COLUMN_GAP.SIZE_10}: 48px;
    ${CARDS_ASPECT_RATIO_VARS.PARTNER_CARD}: 1.3;
    ${BANNER_WIDTH.SIZE_94}: 94.16%;
    ${BANNER_ASPECT_RATIO.SIZE_30}: 2.58;
    ${BANNER_WIDTH.SIZE_66}: 67.3%;
    ${BANNER_ASPECT_RATIO.SIZE_40}: 2.645;

    ${LABEL_PADDINGS.SIZE_10}: 10px 22px;
    ${LABEL_PADDINGS.SIZE_20}: 4px 20px;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL}: 1.006;
    ${EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL}: 1.902;
    ${EVENT_CARD_ASPECT_RATIO.VERTICAL_DEFAULT}: 0.593;
    ${EVENT_CARD_ASPECT_RATIO.HORIZONTAL_DEFAULT}: 1.469;
    ${GRID.PaddingBottomDetailsEpisodes}: var(${FIXED_INDENTS.INDENT_120});
  }
`

export const pinkVariables = css`
  ${COLOR.ACCENT_SECONDARY}: linear-gradient(270deg, #ff00c7 0%, #e61010 100%);
  ${COLOR.ACCENT_PRIMARY_PRESSED}: #b20079;
  ${COLOR.ACCENT_PRIMARY_GRADIENT}: #e3009a;
  ${COLOR.BUTTON_ACCENT_PRIMARY}: #e3009a;
  ${COLOR.BUTTON_ACCENT_PRIMARY_GRADIENT}: #e3009a;
  ${COLOR.CATEGORY_CARD_ACCENT_PRIMARY_GRADIENT}: linear-gradient(
    107.24deg,
    #6c095e 0.45%,
    #7d0b60 26.36%,
    #c31497 72.99%,
    #ac128f 100%
  );
  ${COLOR.ACCENT_TERTIARY}: #e3009a;
  ${COLOR.PROGRESS_BAR_ACCENT_SECONDARY}: linear-gradient(
    270deg,
    #ff00c7 0%,
    #e61010 100%
  );
`
